export default __webpack_public_path__ + "static/media/007-drink water.919fb05e.svg";